import axios from "axios";
import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

const getUserById = async(idUser) => {

  const token = await authHeader();
  const url = `${ baseUrl }/userE1/findById/${idUser}`;
  
  return axios.get(url,
  {headers: token}
  ).then(
      (response) => {
    return response.data;
  })
};

/**
 * Recuperar lista de representantes registrados
 * @param { string } an8 - identificador del cliente
 * @returns {any} recupera la respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Noviembre 2023
 */ 
const getManagersByAN8 = async(an8) => {

  const token = await authHeader();
  
  const url = `${ baseUrl }/manager/find-manager/${an8}`;
  
  return axios.get(url,
  {headers: token}
  ).then(
      (response) => {
    return response.data;
  })
};

/**
 * Recuperar lista de clientes asociados al an8
 * @param { string } an8 - identificador del usuario
 * @returns {any} recupera la respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Noviembre 2023
 */ 
const getCustomersByAN8 = async(an8) => {

  const token = await authHeader();
  
  const url = `${ baseUrl }/user/${an8}`;
  
  return axios.get(url,
  {headers: token}
  ).then(
      (response) => {
    return response.data;
  })
};

const updateCustomersAssociates = async(customerData, an8) => {
  const token = await authHeader();
  const url = `${ baseUrl }/manager/save/${an8}`;
return axios.post(url, customerData,
  {
    headers: token
  }
  ).then(
  (response) => {
  return response.data;
})
};

const getAllUsers = async(group) => {
  const token = await authHeader();
  const url = `${ baseUrl }/userE1/findAll/${group}`;
  return axios
    .get(url, {
      headers: token
    }
      ).then(response => {
      console.log(response.data)
      return response.data;
     }
     )
};

const updateUser = async(userData, idUser) => {
  const token = await authHeader();
  const url = `${ baseUrl }/userE1/update/${idUser}`;
return axios.put(url, userData,
  {
    headers: token
  }
  ).then(
  (response) => {
  return response.data;
})
};

/**
 * Recuperar lista de usuarios asociados al administrador
 * @param { string } an8 - identificador del usuario
 * @returns {any} recupera la respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Noviembre 2023
 */ 
const getCustomerAssociatesByAN8 = async(an8) => {

  const token = await authHeader();
  const url = `${ baseUrl }/manager/user-associated/${an8}`;
  
  return axios.get(url,
  {headers: token}
  ).then(
      (response) => {
    return response.data;
  })
};

/**
 * Realiza el registro de empleados
 * @param { Object } customerData - an8 del cliente
 * @returns {any} recupera la respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Octubre 2023
 */ 
const registerCustomer = async(customerData) => {
  const token = await authHeader();
  const url = `${ baseUrl }/user/employee/list`;
return axios.post(url, customerData,
  {
    headers: token
  }
  ).then(
  (response) => {
  return response.data;
})
};

/**
 * Actualizar estado del usuario
 * @param { string } idUser - identificador del registro
 * @param {boolean} status - nuevo estado del usuario
 * @returns {any} recupera la respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Noviembre 2023
 */ 
const updateCustomerStatus = async(idCustomer, status) => {
  const token = await authHeader();
  const url = `${ baseUrl }/user/update-status/${idCustomer}/${status}`;
return axios.put(url, '',
  {
    headers: token
  }
  ).then(
  (response) => {
  return response.data;
})
};

/**
 * Realiza el registro de empleados
 * @param { Object } customerData - an8 del cliente
 * @returns {any} recupera la respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Noviembre 2023
 */ 
const createCustomer = async(customerData, an8) => {
  const token = await authHeader();
  const url = `${ baseUrl }/manager/save/${an8}`;
return axios.post(url, customerData,
  {
    headers: token
  }
  ).then(
  (response) => {
  return response.data;
})
};

/**
 * Realiza el registro de empleados
 * @param { Object } customerData - an8 del cliente
 * @param { String} idCustomer - identificador del gerente
 * @param { String} an8 - identificador del administrador
 * @returns {any} recupera la respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Noviembre 2023
 */ 
const updateCustomer = async(customerData, idCustomer, an8) => {
  const token = await authHeader();
  const url = `${ baseUrl }/manager/update/${an8}/${idCustomer}`;
return axios.put(url, customerData,
  {
    headers: token
  }
  ).then(
  (response) => {
  return response.data;
})
};

export default {
    getUserById,
    getCustomersByAN8,
    getManagersByAN8,
    getCustomerAssociatesByAN8,
    updateCustomersAssociates,
    getAllUsers,
    updateUser,
    registerCustomer,
    createCustomer,
    updateCustomer,
    updateCustomerStatus
};